import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'prCustomCapitalize',
    standalone: false
})
export class PrCustomCapitalizePipe implements PipeTransform {
  transform(str: string): string {
    if (!str) return '';
    if (str.length < 2) return str.toUpperCase();
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
}
